module.exports = __webpack_public_path__ + "img/mkk_logo.536ba68d.png";